import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const RadioCheckedIcon = props => {
  return (
    <Svg
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18.5a9 9 0 007.871-13.367L8.49 13.276a.803.803 0 01-1.112 0L4.23 10.22a.749.749 0 010-1.081.803.803 0 011.113 0l2.59 2.516 8.056-7.826A9 9 0 109 18.5z"
        fill="#3876AA"
      />
    </Svg>
  );
};

export default RadioCheckedIcon;
